*.container,.context.container,.ad.hoc.container{flex:1;justify-content:flex-end}*.label,.context.label,.ad.hoc.label{text-align:right;width:40px}